import ObjectUtil from "../utils/ObjectUtil";

/**
 * mixin_常用
 */
export default {
    props: {},
    data() {
        return {
            mixin: {
                // 1.枚举和枚举翻译
                enumClasses: []
            }
        }
    },
    async created() {
        // 1.枚举和枚举翻译
        if (this.mixin.enumClasses.length) {
            await this.$store.dispatch('common/dictListComputeIfAbsentEnum', this.mixin.enumClasses.join(','))
        }
    },
    methods: {
        getEnumList(enumClassName) {
            return this.$store.state.dictListMapEnum[enumClassName]
        }
    }
}
